import React, {ReactNode, useState} from "react";
import {FilterState} from "types/filterContext";
import {FilterContext} from "context/FilterContext";

export const FilterProvider: React.FC<{ children: ReactNode }> = ({children}) => {
    const [apiFilters, setApiFiltersState] = useState<FilterState>({
        environment: 'dev',
        region: 'us',
    });

    const setApiFilters = (updated: Partial<FilterState>) => {
        setApiFiltersState((prev) => ({...prev, ...updated}));
    };

    return (
        <FilterContext.Provider value={{apiFilters, setApiFilters}}>
            {children}
        </FilterContext.Provider>
    );
};